import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import BlogPosts from './blog-posts';

const NavLink = props => {
  if (!props.test) {
    return (
      <Link to={`${props.url ? `/page/` : ``}${props.url}`}>
        <div className="button">
          {props.text}
        </div>
      </Link>
    );
  }

  return (
    <span></span>
  );
};

const IndexTemplate = ({ data, pathContext }) => {
  const { group, index, first, last, pageCount, pathPrefix } = pathContext;
  const previousUrl = (index - 1) == 1 ? "" : (index - 1).toString();
  const nextUrl = (index + 1).toString();

  return (
    <section>

      <header
        className="header flex center"
      >
        <div>
          <h1 style={{ margin: 0 }}>
            <Link
              to="/"
              style={{
                color: '#9EABB3',
                textDecoration: 'none',
              }}
            >
              It's like Dropbox, for thoughts.
        </Link>
          </h1>
        </div>
      </header>

      <section className="content">
        <BlogPosts group={group} />

        <section className="pagination">
          <div className="flex start">
            <NavLink test={first} url={previousUrl} text="← Newer Posts" />
          </div>
          <div className="flex center">
            Page {index} of {pageCount}
          </div>
          <div className="flex end">
            <NavLink test={last} url={nextUrl} text="Older Posts →" />
          </div>
        </section>

      </section>

    </section>
  );
}

IndexTemplate.propTypes = {
  children: PropTypes.func,
}

export default IndexTemplate;

export const query = graphql`
  query BlogPostsQuery {
    allMarkdownRemark(
      sort: {
        fields: [frontmatter___date], 
        order: DESC
      }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM YYYY")
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/index.js